'use client';

import { MAP_BOX_ACCESS_TOKEN } from '@/app-constants';
import { MPUMALANGA_COORDS } from '@/data';
import { BroadcastAlert, DispatcherEmsApplicationPlugin } from '@shesha-io/dispatcher';
import {
  GlobalStateProvider,
  FormFullName,
  MainLayout,
  ShaApplicationProvider,
  useNextRouter,
} from '@shesha-io/reactjs';
import { useTheme } from 'antd-style';
import { AppProgressBar } from 'next-nprogress-bar';
import { FC, PropsWithChildren } from 'react';
import { GlobalDevExpressStyles, DevExpressReportingApplicationPlugin } from '@shesha-io/devexpressreporting';

/* NEW_TOOLBOXCOMPONENT_IMPORT_GOES_HERE */

export interface IAppProviderProps {
  backendUrl: string;
  applicationKey?: string;
}

export const HEADER_CONFIGURATION: FormFullName = { name: 'header', module: 'Boxfusion.Dispatcher' };

export const AppProvider: FC<PropsWithChildren<IAppProviderProps>> = ({ children, backendUrl, applicationKey }) => {
  const nextRouter = useNextRouter();
  const theme = useTheme();

  const noAuthRoutes = ['/no-auth', '/login', '/account/forgot-password', '/account/reset-password'];
  const noAuth = Boolean(noAuthRoutes.find((r) => nextRouter.path?.includes(r)));

  return (
    <GlobalStateProvider>
      <GlobalDevExpressStyles />
      <AppProgressBar height="4px" color={theme.colorPrimary} shallowRouting />
      <ShaApplicationProvider
        backendUrl={backendUrl}
        router={nextRouter}
        noAuth={nextRouter.path?.includes('/no-auth')}
        applicationKey={applicationKey}
      >
        <DevExpressReportingApplicationPlugin>
          <DispatcherEmsApplicationPlugin
            backEndUrl={backendUrl}
            accessToken={MAP_BOX_ACCESS_TOKEN}
            polygons={MPUMALANGA_COORDS}
          >
            <BroadcastAlert />
            {noAuth ? (
              <>{children}</>
            ) : (
              <MainLayout headerFormId={HEADER_CONFIGURATION} noPadding>
                {children}
              </MainLayout>
            )}
          </DispatcherEmsApplicationPlugin>
        </DevExpressReportingApplicationPlugin>
      </ShaApplicationProvider>
    </GlobalStateProvider>
  );
};
